export default ({ header, text, type }) => {
	return (
		(
			<div className="form-text">
				{header && (type === 'lead' ? <h1>
					{header}
				</h1> : <h3>{header}</h3>)}
				<div className="text" dangerouslySetInnerHTML={{ __html: text }} />
			</div>
		)
	)
}
